import { Grid, Box, Typography, Button, IconButton } from "@deere/fuel-react";
import { Form } from "@deere/ux.uxframe-react";
import { DEFAULT_GRID_COLLUMNS, OS_CONTACT_PARENT_ANS } from "../../utils/surveyLiterals";
import { ReactComponent as AddIcon } from "@deere/ux.brand-foundations/icons/add.svg";
import { useTranslation } from "react-i18next";
import OSReviewContactTables from "./OSReviewContactTables";
import { ReactComponent as DeleteIcon } from "@deere/ux.brand-foundations/icons/delete.svg";

const OSContactSection = ({ questions, getCollumnsByQuestion, createRadioSection, createInput, createCountrySection, answers, osContacts, handleAddAnother, review, deleteOSContact }) => {
  const { t } = useTranslation();
  const directQuestion = questions.find((que) => !que.code.includes("MULTI")); // Normal Survey Questions
  const contactQuestions = questions.filter((que) => que.code.includes("MULTI")); // Questions which are part of ownership contacts box.
  const directQuestionAns = answers.find((item) => item.questionId === directQuestion.id);
  const validOSContacts = osContacts.filter((osc) => osc.deleted !== true);

  const contactQuestionBox = (contact) => {
    return contactQuestions
      .sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1))
      .map((q) => {
        const collumnsByQuestion = q.questionsGroup ? getCollumnsByQuestion(contactQuestions, q.questionsGroup) : DEFAULT_GRID_COLLUMNS;
        const openSmallStyle = q.type !== "RADIO" ? { paddingLeft: 10, paddingRight: 10 } : {};
        let inputComponent = "";
        if (q.type === "RADIO" && (q.dependentQuestions === "undefined" || q.dependentQuestions.length <= 0)) {
          inputComponent = createRadioSection(q, contact);
        } else if (q.type === "OPEN_SMALL" && (q.dependentQuestions === "undefined" || q.dependentQuestions.length <= 0)) {
          inputComponent = createInput(q, contact);
        } else if (q.type === "OPTION_CTY" && (q.dependentQuestions === "undefined" || q.dependentQuestions.length <= 0)) {
          inputComponent = createCountrySection(q, contact);
        }
        return inputComponent ? (
          <Grid key={`gq-${q.id}`} item md={collumnsByQuestion} style={openSmallStyle}>
            <Form.Row className="d-block mb-4">{inputComponent}</Form.Row>
          </Grid>
        ) : (
          ""
        );
      });
  };

  return (
    <Grid item>
      <div style={{ paddingLeft: 10 }}>
        <Form.Row className="d-block mb-4">
          {directQuestion.type === "RADIO" && (directQuestion.dependentQuestions === "undefined" || directQuestion.dependentQuestions.length <= 0) ? createRadioSection(directQuestion) : <></>}
        </Form.Row>
      </div>
      {directQuestionAns &&
        directQuestionAns.answer === OS_CONTACT_PARENT_ANS &&
        validOSContacts.length > 0 &&
        (review ? (
          <OSReviewContactTables osContacts={validOSContacts} questions={questions} />
        ) : (
          <>
            {validOSContacts.map((contact) => {
              return (
                <Box bgcolor="white" border="1px solid grey" padding={4} mb={4} key={contact.id}>
                  <Grid container style={{ paddingLeft: 5, paddingRight: 5 }}>
                    <Grid item md={11}>
                      <Typography component="p" size="md" fontWeight="semibold" paddingBottom={4}>
                        {t("os_contact_box_header")}
                      </Typography>
                    </Grid>
                    <Grid item md={1} style={{ textAlign: "right" }}>
                      <IconButton
                        outlined
                        onClick={() => {
                          deleteOSContact(contact.id);
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                  <Grid container>{contactQuestionBox(contact)}</Grid>
                </Box>
              );
            })}
            <Grid container justifyContent="flex-end">
              <Button variant="secondary" onClick={handleAddAnother}>
                <AddIcon /> Add Another
              </Button>
            </Grid>
          </>
        ))}
    </Grid>
  );
};

export default OSContactSection;
